import { Coffee } from "lucide-react";

function Preview({ bg, border, caseDisplay, label, isDashed = false }: {
    bg: string;
    border: string;
    caseDisplay: string;
    label: string;
    isDashed?: boolean;
}) {
    const textStyle: React.CSSProperties = {
        textTransform: caseDisplay === "normal" ? "none" : caseDisplay as React.CSSProperties["textTransform"],
    };

    return (
        <div
            className="tw-rounded-md tw-px-3 tw-py-4 tw-flex tw-flex-col tw-justify-center tw-flex-1 tw-min-w-0"
            style={isDashed
                ? { backgroundColor: bg, borderColor: border, borderStyle: "dashed", borderWidth: "2px" }
                : { backgroundColor: bg, borderLeftColor: border, borderLeftStyle: "solid", borderLeftWidth: "2px" }
            }
        >
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
                <span className="tw-text-xs tw-font-bold tw-text-neutral-800" style={textStyle}>8h 00m</span>
                <div className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-primary">
                    <Coffee size={12} />
                    <span>0h 30m</span>
                </div>
            </div>
            <div className="tw-text-xs tw-text-neutral-600 tw-truncate" style={textStyle}>
                REG • {label}
            </div>
        </div>
    );
}

export default Preview;
